// extracted by mini-css-extract-plugin
module.exports = {"main":"NotificationList_main__J3wZR","loadButton":"NotificationList_loadButton__1kBrK","loading":"NotificationList_loading__r2tFf"};